import { render } from "./OpeningAnnouncement.vue?vue&type=template&id=74f2dd67"
import script from "./OpeningAnnouncement.vue?vue&type=script&lang=js"
export * from "./OpeningAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__